import React, { Component, Fragment } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Col, Label, Input } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../i18next';

import { getCurrencySymbol } from '../../../../utils/CommonUtils';

class AddValueTimeExtensionsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: null,
            money: null,
            minutes: null
        }
    }

    componentDidMount() {
        if (this.props.currentValueTimeExtension) {
            const { id, money, minutes } = this.props.currentValueTimeExtension;

            this.setState({
                id,
                money,
                minutes
            })
        }
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    changeState = ({target}) => {
        this.setState({
            ...this.state,
            [target.name]: target.value
        })
    }

    renderContent() {
        const { titleCol, labelStyle, noPadding } = styles;
        const currency = getCurrencySymbol(this.props.currency);

        return (
            <Fragment>
                <AvGroup sm={12} style={titleCol}>
                    <Label sm={5} style={labelStyle}>{i18n.t('common:form.over')}</Label>
                    <Col sm={7} style={noPadding}>
                        <AvField
                            placeholder={currency}
                            type="number"
                            min={0}
                            name="money"
                            required={true}
                            value={this.state.money}
                            onChange={this.changeState}
                            onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                            errorMessage={i18n.t('common:validations.errorMsg')}
                            />
                    </Col>
                </AvGroup>
                <AvGroup sm={12} style={titleCol}>
                    <Label sm={5} style={labelStyle}>{i18n.t('common:form.cookTime')}</Label>
                    <Col sm={7} style={noPadding}>
                        <AvField
                            placeholder={i18n.t('common:form.minutes')}
                            type='number'
                            min={0}
                            name='minutes'
                            required={true}
                            onChange={this.changeState}
                            value={this.state.minutes}
                            onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                            errorMessage={i18n.t('common:validations.errorMsg')}
                            />
                    </Col>
                </AvGroup>
            </Fragment>
        );
    }

    render() {
        const isApplyBtnDisabled = !this.state.money  || !this.state.minutes;

        return (
            <Modal isOpen={this.props.isOpen} toggle={() => this.props.onToggle()}>
                <ModalHeader className="modalHeader" toggle={() => this.props.onToggle()}>{i18n.t('screens:generalScreen.addOrderValueTimeExtensions')}</ModalHeader>
                <ModalBody>
                    <AvForm>
                        {this.renderContent()}
                    </AvForm>
                </ModalBody>

                <ModalFooter>
                    {
                        this.props.currentValueTimeExtension ?
                            <Button
                                color="primary" outline style={{ display: 'flex', alignItems: 'center' }}
                                onClick={() => this.props.onSave(this.state, this.props.currentValueTimeExtensionIndex, true)}
                                >
                                <span style={{ marginBottom: 1 }}>
                                    <MaterialIcon icon="delete" color="#0288D1" size={18} />
                                </span>
                                {i18n.t('common:buttons.delete')}
                            </Button> : null
                    }
                    <Button color="primary" onClick={() => this.props.onSave(this.state, this.props.currentValueTimeExtensionIndex)} disabled={isApplyBtnDisabled}>
                        <MaterialIcon icon="check" color="#fff" size={20} />&nbsp;{i18n.t('common:buttons.apply')}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default AddValueTimeExtensionsModal;

let styles = {
    titleCol: {
        display: 'flex',
        justifyContent: 'flex-start'
    },
    labelStyle: {
        padding: '12px 16px 12px 0px'
    },
    noPadding: {
        padding: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/AddValueTimeExtensionsModal.js